"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Additives = exports.Additional = exports.Dish = exports.SmallHeadline = void 0;
var SpeisekarteModel = /** @class */ (function () {
    function SpeisekarteModel() {
    }
    return SpeisekarteModel;
}());
exports.default = SpeisekarteModel;
var SmallHeadline = /** @class */ (function () {
    function SmallHeadline() {
    }
    return SmallHeadline;
}());
exports.SmallHeadline = SmallHeadline;
var Dish = /** @class */ (function () {
    function Dish() {
    }
    return Dish;
}());
exports.Dish = Dish;
var Additional = /** @class */ (function () {
    function Additional() {
    }
    return Additional;
}());
exports.Additional = Additional;
var Additives = /** @class */ (function () {
    function Additives() {
    }
    return Additives;
}());
exports.Additives = Additives;
//# sourceMappingURL=SpeisekarteModel.js.map